/**
 * Buy-box pricing for the product page.
 *
 * One resolver with three consumers: the Add to Cart button, the pack cards in
 * the variant picker, and the sticky bar. They have to agree to the cent — the
 * button now carries the price, so a sticky bar that disagreed with it would be
 * visible on the same screen — and the logic below has a few decisions in it
 * that are easy to get subtly different when copied.
 *
 * @author Maksym Mariukhnik <max@absoluteweb.com>
 */
window.PSPrice = (function () {
  'use strict';

  function format(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /**
   * Id of the subscription plan currently selected inside `root`, or '' for a
   * one-time purchase.
   *
   * Resolved the same way the add-to-cart path resolves it (buildPayload in
   * ps-atc-feedback.js), so the displayed price always matches what actually
   * gets added: the purchaseType radio is the authoritative signal for One-Time
   * vs Subscribe, and the frequency <select> only supplies the id. Reading the
   * radio rather than the hidden selling_plan input or the <select> alone
   * avoids a stale plan — Safari's bfcache can keep the <select> populated
   * while One-Time is checked, which would price the page as a subscription.
   */
  function planId(root) {
    if (!root) return '';
    var purchaseType = root.querySelector('input[name="purchaseType"]:checked');
    var isSubscription = !!(purchaseType && /subscription/i.test(purchaseType.value));
    if (!isSubscription) return '';
    var planSelect = root.querySelector('select[name="stayai_selling_plan"]');
    return planSelect && planSelect.value ? planSelect.value : '';
  }

  /**
   * What to show for `variant` under the given plan.
   *
   * Returns { price, compareAt } in cents. compareAt is null when there is
   * nothing to strike through.
   */
  function resolve(variant, id) {
    if (!variant) return { price: null, compareAt: null };

    var alloc = null;
    if (id && variant.selling_plan_allocations) {
      alloc = variant.selling_plan_allocations.find(function (a) {
        return String(a.selling_plan_id) === String(id);
      }) || null;
    }

    var price = alloc
      ? (alloc.per_delivery_price != null ? alloc.per_delivery_price : alloc.price)
      : variant.price;

    // For a subscription, mirror StayAI: strike through the one-time variant
    // price — the saving the plan advertises — and not alloc.compare_at_price,
    // which is the RRP and is often null, hiding the strikethrough entirely.
    var compareAt = alloc ? variant.price : variant.compare_at_price;
    if (!(compareAt && compareAt > price)) compareAt = null;

    return { price: price, compareAt: compareAt };
  }

  return {
    format: format,
    planId: planId,
    resolve: resolve,
  };
})();
